import { API_BASE_URL, API_COMPANY_ID, API_ENDPOINTS } from '../constants';

class SimCheck extends HTMLElement {
  constructor() {
    super();

    // Device data
    this.devices = JSON.parse(this.querySelector('[data-devices-json]').innerHTML);

    // Setup elements
    this.form = this.querySelector('[data-check-form]');
    this.brandSelect = this.querySelector('[data-brand-select]');
    this.deviceSelect = this.querySelector('[data-device-select]');
    this.imeiField = this.querySelector('[data-imei-field]');
    this.submitButtons = this.querySelectorAll('[data-submit-button]');
    this.successMessage = this.querySelector('[data-success-message]');
    this.successMessageDevice = this.querySelector('[data-success-message-device]');
    this.failedMessage = this.querySelector('[data-failed-message]');
    this.errorMessage = this.querySelector('[data-error-message]');
    this.resetButtons = this.querySelectorAll('[data-reset-button]');
    this.closeButtons = this.querySelectorAll('[data-close-dialog]');

    // Initialize the options
    this.setupDeviceSelect();

    // Bind event handlers
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.brandSelect.addEventListener('change', this.handleBrandChange.bind(this));
    this.deviceSelect.addEventListener('change', this.handleDeviceChange.bind(this));
    this.imeiField.addEventListener('input', this.handleImeiInput.bind(this));
    this.resetButtons.forEach((button) => {
      button.addEventListener('click', this.handleReset.bind(this));
    });
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.handleReset.bind(this));
    });
  }

  setupDeviceSelect() {
    const brands = Object.keys(this.devices);

    this.brandSelect.innerHTML = [
      `<option value="" selected>${this.brandSelect.dataset.placeholder}</option>`,
      brands.map((brand) => {
        return `<option value="${brand}">${brand}</option>`;
      }),
    ];
  }

  handleImeiInput() {
    this.resetBrandSelect();
    this.validateForm();
  }

  handleBrandChange() {
    const brand = this.brandSelect.value;

    const placeholder = `<option value="" selected>${this.deviceSelect.dataset.placeholder}</option>`;

    // Reset the device select if no brand is selected
    if (brand === '') {
      this.deviceSelect.innerHTML = placeholder;
      this.deviceSelect.disabled = true;
      return;
    }

    const devices = this.devices[brand];
    this.deviceSelect.innerHTML = [
      placeholder,
      ...devices.map((device) => {
        return `<option value="${brand} ${device}">${device}</option>`;
      }),
    ];

    this.deviceSelect.disabled = false;
    this.resetImeiField();
    this.validateForm();
  }

  handleDeviceChange() {
    this.validateForm();
  }

  handleReset() {
    this.resetBrandSelect();
    this.resetImeiField();
    this.validateForm();

    this.successMessage.classList.add('hidden');
    this.failedMessage.classList.add('hidden');
    this.form.classList.remove('hidden');
  }

  validateForm() {
    const imei = this.imeiField.value;
    const device = this.deviceSelect.value;

    if (imei.length >= 15 || device !== '') {
      this.submitButtons.forEach((button) => {
        button.disabled = false;
      });
    } else {
      this.submitButtons.forEach((button) => {
        button.disabled = true;
      });
    }
  }

  resetBrandSelect() {
    this.brandSelect.value = '';
    this.handleBrandChange();
  }

  resetImeiField() {
    this.imeiField.value = '';
  }

  showSuccessMessage(deviceName) {
    if (this.successMessageDevice) {
      this.successMessageDevice.innerHTML = deviceName ? deviceName : 'device';
    }

    this.successMessage.classList.remove('hidden');
    this.failedMessage.classList.add('hidden');
    this.form.classList.add('hidden');
  }

  showFailedMessage() {
    this.failedMessage.classList.remove('hidden');
    this.successMessage.classList.add('hidden');
    this.form.classList.add('hidden');
  }

  showErrorMessage() {
    this.errorMessage.classList.remove('hidden');
  }

  hideErrorMessage() {
    this.errorMessage.classList.add('hidden');
  }

  async fetchImeiData(imei) {
    this.submitButtons.forEach((button) => {
      button.classList.add('loading');
    });

    this.hideErrorMessage();

    try {
      const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.IMEI_CHECK}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          companyId: API_COMPANY_ID,
          imei,
        }),
      });

      const responseData = await response.json();

      if (responseData.Status != true) {
        this.showErrorMessage();
      } else {
        if (responseData.data.compatibility === 'COMPATIBLE') {
          this.showSuccessMessage(responseData.data.deviceName);
        } else {
          this.showFailedMessage();
        }
      }
    } catch (error) {
      console.error(error);
      this.showErrorMessage();
    } finally {
      this.submitButtons.forEach((button) => {
        button.classList.remove('loading');
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    // Reset messages
    this.failedMessage.classList.add('hidden');

    // Check if a device is selected
    if (this.deviceSelect.value !== '') {
      this.showSuccessMessage();
      return;
    }

    // Check if an IMEI is entered
    if (this.imeiField.value.length >= 15) {
      const imei = this.imeiField.value;
      this.fetchImeiData(imei);
      return;
    }

    // Show an error message if no device or IMEI is selected
    this.showFailedMessage();
  }
}

customElements.define('sim-check', SimCheck);
